<mat-stepper [linear]="true" #stepper>
  <mat-step [completed]="false" [stepControl]="consentForm" #firstStep>
    <ng-template matStepLabel>Veuillez remplir les données</ng-template>
    <h1 class="text-center text-responsive" id="header">
      {{textConfig?.pageOneFirstTitle}}
    </h1>
    <div class="col-sm-12 col-md-12" id="text">
      <h2 class="text-responsive">{{textConfig?.pageOneSecondTitle}}</h2>
      <h3 class="text-responsive">
        {{textConfig?.pageOneThirdTitle}}</h3>
      <div [innerHTML]="textConfig?.pageOneBodyText">
      </div>
    </div>
    <div id="form">
      <div class="row" id="form-header">
        <h2 class="offset-sm-1 offset-md-4 col-sm-4 text-responsive">Informations obligatoires à remplir :</h2>
      </div>
      <ng-template [ngIf]="state == 'loading'">
        <mat-progress-spinner style="margin: auto;" mode="indeterminate"></mat-progress-spinner>
      </ng-template>
      <form id="consentmentForm" *ngIf="state == 'loaded'" [formGroup]="consentForm" class="col-sm-12 ml-5" #ngForm="ngForm">
        <div id="inputContainer" class="row" *ngFor="let row of formTemplateArray; let rowIndex = index">
          <div [ngClass]="columnIndex > 0 ? 'offset-lg-2' : ''" class="col-sm-2 form-group" *ngFor="let column of row; let columnIndex = index">
            <div [ngStyle]="{'cursor': column.disabled === true ? 'not-allowed' : '' }" *ngIf="formData[columnIndex + (inputPerRow * rowIndex)].options == ''">
              <div>
                <label [for]="formData[columnIndex + (inputPerRow * rowIndex)].name">
                  {{formData[columnIndex + (inputPerRow * rowIndex)].label}}
                  <span style="color: red" *ngIf="formData[columnIndex + (inputPerRow * rowIndex)].required == 'true'">
                    *
                  </span>
                  <span *ngIf="formData[columnIndex + (inputPerRow * rowIndex)].required == 'false'">
                    (Facultatif)
                  </span>
                   :
                </label>
                <input [autocomplete]="formData[columnIndex + (inputPerRow * rowIndex)].autocomplete" type="text" [ngClass]="{'is-invalid': ngForm.submitted && column.errors}" class="form-control" [id]="formData[columnIndex + (inputPerRow * rowIndex)].name" [formControl]="column">
                <div class="invalid-feedback">
                  <div *ngIf="column.errors?.required">
                    Ce champs est obligatoire.
                  </div>
                  <div *ngIf="column.errors?.pattern">
                    {{formData[columnIndex + (inputPerRow * rowIndex)].validationErrorMessage}}
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="formData[columnIndex + (inputPerRow * rowIndex)].options != ''">
              <label [for]="formData[columnIndex + (inputPerRow * rowIndex)].name">{{formData[columnIndex + (inputPerRow * rowIndex)].label}}</label>
              <select [ngClass]="{'is-invalid': ngForm.submitted && column.errors}" class="form-control" aria-label="Default select example" [formControl]="column">
                <option *ngFor="let option of extractOptions(formData[columnIndex + (inputPerRow * rowIndex)].options)" [value]="option">
                  {{option}}
                </option>
              </select>
              <div class="invalid-feedback">
                Ce champs est obligatoire.
              </div>
            </div>
          </div>
        </div>
        <div>
          (<span style="color: red">*</span>) À renseigner obligatoirement
        </div>
        <div class="offset-sm-7 offset-md-10">
          <button id="nextButton" color="primary" mat-raised-button matStepperNext>Suivant</button>
        </div>
      </form>
    </div>
  </mat-step>
  <mat-step [completed]="false" [stepControl]="confirmForm" #secondStep>
    <ng-template matStepLabel>Confirmation</ng-template>
    <h1 class="text-center text-responsive" id="confirmationHeader">
      {{textConfig?.pageTwoFirstTitle}}
    </h1>
    <div id="confirmationForm">
      <div class="row" id="confirmFormHeader">
        <form [formGroup]="confirmForm" class="col-sm-12 ml-5" #confirmFormHTML="ngForm">
          <div class="row">
            <div class="consent-checkbox offset-1 col-sm-2">
              <mat-checkbox required="true" color="primary" [ngClass]="{'is-invalid': confirmFormHTML.submitted && confirmForm.get('consent')?.errors}" class="mt-7 ml-7 float-right" formControlName="consent"></mat-checkbox>
            </div>
            <div class="col-sm-6">
              <h2 class="text-responsive">{{textConfig?.pageTwoSecondTitle}}</h2>
              <p>
                {{textConfig?.pageTwoBodyText}}
              </p>
            </div>
          </div>
          <div class="row mt-3">
            <div class="offset-lg-1 offset-sm-1 col-sm-1">
              <button mat-raised-button matStepperPrevious>Précédent</button>
            </div>
            <div class="offset-lg-8 offset-sm-6 mr-5 col-sm-1">
              <button (click)="accept()" color="primary" mat-raised-button matStepperNext>J'accepte</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </mat-step>
  <mat-step [completed]="false">
    <ng-template matStepLabel>Terminé</ng-template>
    <div class="row center">
      <div class="offset-sm-4 col-sm-2">
        <h2>{{textConfig?.pageThreeFirstTitle}}</h2>
      </div>
      <div class="col-sm-3">
        <h2>
          {{textConfig?.pageThreeSecondTitle}}
        </h2>
        <div>
          {{textConfig?.pageThreeBodyText}}
        </div>
      </div>
    </div>
  </mat-step>
</mat-stepper>
